import { submitQuiz } from "@/services/quizService";
import { useMutation } from "@tanstack/react-query";

export const useQuizSubmit = () => {
  const mutation = useMutation({
    mutationFn: submitQuiz,
  });

  return mutation;
};
